import Axios from "axios";
import { runInAction } from "mobx";
import React, { useContext, useEffect } from "react";
import Store from "../store/Store";
import { observer } from "mobx-react-lite";

const SystemLabel = observer(({ name, groupName, textOnly = false }) => {
  const store = useContext(Store);
  groupName = groupName || "Cms.Content";
/*   name = name.toUpperCase(); */
  const label = store.systemLabels[groupName] ? store.systemLabels[groupName][name] : null;
  const { lang } = store.environment;
  useEffect(() => {
    if (typeof store.systemLabels[groupName] !== "object" && store.systemLabels[groupName] !== "Loading") {
      getGroup();
    } else if (typeof store.systemLabels[groupName] === "object") {
      if (!label) createLabel();
    }
  }, [store.systemLabels[groupName], label]);
  function getGroup() {
    runInAction(() => {
      store.systemLabels[groupName] = "Loading";
    });
    Axios.get(`./api/systemLabel/group/?groupName=${groupName}&languageCode=${lang}`).then(({ data }) => {
      runInAction(() => {
        const groups = { ...store.systemLabels };
        const groupData = {};
        data.map((d) => {
          groupData[d.name] = d;
        });
        groups[groupName] = groupData;
        store.systemLabels = groups;
      });
    });
  }
  function createLabel() {
    runInAction(() => {
      store.systemLabels[groupName][name] = "Loading";
    });
    Axios.get(`./api/systemLabel?groupName=${groupName}&name=${name}&languageCode=${lang}`).then(({ data }) => {
      runInAction(() => {
        const groups = { ...store.systemLabels };
        groups[groupName][name] = data.label;
        store.systemLabels = groups;
      });
    });
  }
  if (textOnly) return label || label === "Loading" ? label.value : `#${name}#`;
  if (!label || label === "Loading") return <span>{`#${name}#`}</span>;
  return <span style={{ display: "flex", alignItems: "center" }}>{label.value}</span>;
});
export default SystemLabel;
